<template>
    <div>
        <div class="fun">
            <div class="fun_title">{{ $t('now_add_fun') }}</div>
            <div class="adsizeBorder">
                <div class="fun_subtitle">
                    <span>{{ $t('fun_your') }}</span>
                    <div class="circle"></div>
                    <div class="striping"></div>
                </div>
                <div class="fun_yours">
                    <el-carousel class="fun_yours_imgs" trigger="click" :autoplay="false">
                        <el-carousel-item v-for="(item, index) in userInfo.media" :key="index">
                            <img :src="item.mediaUrl" alt="" />
                        </el-carousel-item>
                    </el-carousel>
                    <div class="yours_info">
                        <div class="yours_info_name">{{ userInfo.productName }}</div>
                        <div class="yours_info_param1">
                            <p>{{ $t('length') }}</p>
                            <span>{{ userInfo.length }}英尺</span>
                        </div>
                        <div class="yours_info_param1">
                            <p>{{ $t('capacity') }}</p>
                            <span>最多 {{ userInfo.maxPassenger }} 人</span>
                        </div>
                        <div class="yours_info_param1">
                            <p>{{ $t('crew') }}</p>
                            <span>{{ userInfo.crewNum }}+{{ userInfo.captainNum }}</span>
                        </div>
                        <div class="yours_info_param2">
                            <p>{{ $t('departure_date') }}</p>
                            <span
                                >{{ dayjs(userInfo.date).format('YYYY年MM月DD日') }}
                                {{ weekCh[dayjs(userInfo.date).format('d')] }}
                                {{
                                    userInfo.time
                                        ? +userInfo.time.split(':')[0] > 12
                                            ? '下午 ' + (+userInfo.time.split(':')[0] - 12) + ' 点'
                                            : '上午 ' + userInfo.time.split(':')[0] + ' 点'
                                        : ''
                                }}
                            </span>
                        </div>
                        <div class="yours_info_param2">
                            <p>{{ $t('duration') }}</p>
                            <span>{{ userInfo.hour ? userInfo.hour + ' 个小时' : $t('order.hour') }} </span>
                        </div>
                        <div class="yours_info_param2">
                            <p>{{ $t('departure_point') }}</p>
                            <span>{{ userInfo.berth }}</span>
                        </div>
                        <div class="yours_info_param3">
                            <p>{{ $t('Guests') }}</p>
                            <span>{{ userInfo.adult }}</span>
                            <span>{{ userInfo.child }}</span>
                        </div>
                    </div>
                </div>
                <div class="fun_subtitle">
                    <span>{{ $t('on_board_catering') }}</span>
                    <div class="circle"></div>
                    <div class="striping"></div>
                </div>
                <div class="fun_board">
                    <div class="boards">
                        <div class="boards_title">
                            <p class="boards_menus">{{ $t('boards_menus') }}</p>
                            <p class="boards_details">{{ $t('boards_details') }}</p>
                            <p class="boards_price">{{ $t('boards_price') }}</p>
                            <p class="boards_quantity">{{ $t('boards_quantity') }}</p>
                        </div>
                        <div class="boards_main" v-for="item in $store.state.order.yachtsMenu" :key="item.id">
                            <p class="boards_menus">
                                <el-image
                                    :src="require('@/assets/camera_icon.png')"
                                    :preview-src-list="[item.imageUrl]"
                                    @click="previewPic"
                                >
                                </el-image>
                                <span :title="item.menuName">{{ item.menuName }}</span>
                            </p>
                            <p :title="item.detailDescribe" class="boards_details textHidden">
                                {{ item.detailDescribe }}
                            </p>
                            <p class="boards_price" :title="'AED ' + item.price + (item.priceType == 1 ? 'pp' : '')">
                                AED {{ item.price }}
                                <span v-if="item.priceType == 1"> pp</span>
                            </p>
                            <p class="boards_quantity">
                                <el-select
                                    v-model="item.number"
                                    placeholder="0"
                                    :popper-append-to-body="false"
                                    popper-class="optionsContents"
                                    @change="menus(item.number, item.id)"
                                >
                                    <el-option :value="0">0</el-option>
                                    <el-option
                                        :value="i + (item.minNumber ? item.minNumber : 1)"
                                        v-for="(items, i) in item.minNumber
                                            ? item.maxNumber - item.minNumber + 1
                                            : item.maxNumber"
                                        :key="i"
                                    >
                                        {{ item.minNumber ? item.minNumber + i : 1 + i }}
                                    </el-option>
                                </el-select>
                            </p>
                        </div>
                    </div>
                </div>
                <div class="fun_subtitle">
                    <span>{{ $t('sport_title') }}</span>
                    <div class="circle"></div>
                    <div class="striping"></div>
                </div>
                <div class="fun_sports">
                    <div class="sports">
                        <div class="boards_title sports_title">
                            <p class="boards_menus">{{ $t('sports_menus') }}</p>
                            <p class="boards_details">{{ $t('sports_unit') }}</p>
                            <p class="boards_price">{{ $t('sports_price') }}</p>
                            <p class="boards_quantity">{{ $t('sports_quantity') }}</p>
                        </div>
                        <div class="boards_main" v-for="item in $store.state.order.waterSports" :key="item.id">
                            <p class="boards_menus">
                                <el-image
                                    :src="require('@/assets/camera_icon.png')"
                                    :preview-src-list="[item.imageUrl]"
                                    @click="previewPic"
                                ></el-image>
                                <span :title="item.serviceName">{{ item.serviceName }}</span>
                            </p>
                            <p class="boards_details sports_unit" style="padding-right: 12px">
                                {{ item.unit }}
                            </p>
                            <p class="boards_price sports_price">
                                <span class="price" :title="'AED ' + item.price">AED {{ item.price }}</span>
                                <el-checkbox
                                    v-model="item.checked"
                                    @change="sportsCheckedChange(item.checked, item.number, item.id)"
                                ></el-checkbox>
                            </p>
                            <p v-show="!item.lockNumber" class="boards_quantity">
                                <el-select
                                    v-model="item.number"
                                    placeholder="0"
                                    :popper-append-to-body="false"
                                    popper-class="optionsContents"
                                    @change="sportsNumChange(item.checked, item.number, item.id)"
                                    ><el-option :value="0">0</el-option>
                                    <el-option
                                        v-for="(items, index) in item.maxNumber"
                                        :key="index"
                                        :value="items"
                                    ></el-option>
                                </el-select>
                            </p>
                            <p v-if="item.lockNumber" class="sports_duration">{{ item.defaultNumber }} 小时</p>
                        </div>
                        <div class="boards_title toys_title">
                            <p class="boards_menus">{{ $t('toys_menus') }}</p>
                            <p class="boards_details">{{ $t('toys_unit') }}</p>
                            <p class="boards_price">{{ $t('toys_price') }}</p>
                            <p class="boards_quantity">{{ $t('toys_quantity') }}</p>
                        </div>
                        <div class="boards_main Yacht_Toys" v-for="v in $store.state.order.yachtsToys" :key="v.id">
                            <p class="boards_menus">
                                <el-image
                                    :src="require('@/assets/camera_icon.png')"
                                    :preview-src-list="[v.imageUrl]"
                                    @click="previewPic"
                                ></el-image>
                                <span :title="v.serviceName">{{ v.serviceName }}</span>
                            </p>
                            <p class="boards_details sports_unit" style="padding-right: 12px">
                                {{ v.unit }}
                            </p>
                            <p class="boards_price sports_price toys_price">
                                <span :title="'AED ' + v.price" class="price">AED {{ v.price }}</span>
                                <el-checkbox
                                    v-model="v.checked"
                                    @change="toysCheckedChange(v.checked, v.number, v.id)"
                                ></el-checkbox>
                            </p>
                            <p :title="v.detailDescribe" class="sports_duration toys_detail toys_lock">
                                {{ v.detailDescribe ? v.detailDescribe : '------' }}
                            </p>
                        </div>
                    </div>
                </div>
                <div class="fun_subtitle">
                    <span>{{ $t('booking_summary') }}</span>
                    <div class="circle"></div>
                    <div class="striping"></div>
                </div>
            </div>
            <div class="fun_booking">
                <div class="booking">
                    <div class="booking_main">
                        <el-form class="booking_form" ref="dataForm" :model="userInfo">
                            <el-form-item :label="$t('Name')">
                                <el-input :readonly="true" v-model="userInfo.name"></el-input>
                            </el-form-item>
                            <el-form-item class="OrderPhone" :label="$t('Phone')">
                                <el-input
                                    :readonly="true"
                                    class="Order_booking_code"
                                    v-model="userInfo.code"
                                ></el-input>
                                <el-input :readonly="true" class="booking_mobile" v-model="userInfo.phone"></el-input>
                            </el-form-item>
                            <el-form-item :label="$t('e_mail')">
                                <el-input v-model="userInfo.email"></el-input>
                            </el-form-item>
                            <el-form-item class="guestsForm" :label="$t('Guests')">
                                <el-input :readonly="true" class="guestsAdult" v-model="userInfo.adult"></el-input>
                                <el-input :readonly="true" class="guestsChild" v-model="userInfo.child"></el-input>
                            </el-form-item>
                            <el-form-item :label="$t('Date')">
                                <el-input
                                    :readonly="true"
                                    :value="
                                        dayjs(userInfo.date).format('YYYY年MM月DD日') +
                                        ' ' +
                                        weekCh[dayjs(userInfo.date).day()]
                                    "
                                ></el-input>
                            </el-form-item>
                            <el-form-item :label="$t('order.departure_time')">
                                <!-- 时间选择器 -->
                                <el-select
                                    v-model="selectTime"
                                    :placeholder="$t('order.time')"
                                    @change="orderSelectTime"
                                >
                                    <el-option
                                        v-for="item in timeOptions"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value"
                                    >
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item :label="$t('Hours')">
                                <el-select
                                    popper-class="selectHours"
                                    v-model="selectHours"
                                    :placeholder="$t('order.hour')"
                                    @change="changeSelectHours"
                                >
                                    <el-option
                                        v-for="item in hoursOptions"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value"
                                    >
                                    </el-option>
                                </el-select>
                            </el-form-item>

                            <el-form-item :label="$t('Location')">
                                <el-input :readonly="true" v-model="userInfo.berth"></el-input>
                            </el-form-item>
                        </el-form>
                        <div class="booking_total">
                            <div class="booking_price">
                                <div>
                                    <p>{{ $t('charters') }}</p>
                                    <span>AED {{ payTotal.charter }}</span>
                                </div>
                                <div>
                                    <p>{{ $t('catering') }}</p>
                                    <span>AED {{ payTotal.catering }}</span>
                                </div>
                                <div class="booking_price_bar">
                                    <p>{{ $t('extras') }}</p>
                                    <span>AED {{ payTotal.extras }}</span>
                                </div>
                                <div class="booking_all_price">
                                    <p>
                                        {{ $t('total') }}
                                        <span class="total_inc">{{ $t('total_inc') }}</span>
                                    </p>
                                    <span>AED {{ payTotal.total }}</span>
                                </div>
                            </div>
                            <div class="booking_check">
                                <div>
                                    <el-checkbox v-model="serviceChecked"></el-checkbox>
                                    <span>
                                        {{ $t('agree') }}
                                        <a href="javascript:;" @click="toService">
                                            {{ $t('agreerout') }}
                                        </a>
                                    </span>
                                </div>
                                <div>
                                    <el-checkbox v-model="cancellationChecked"></el-checkbox>
                                    <span>
                                        {{ $t('policy') }}
                                        <a href="javascript:;" @click="toPolicy">
                                            {{ $t('policyrout') }}
                                        </a>
                                    </span>
                                </div>
                            </div>
                            <div class="booking_pay">
                                <span>{{ $t('secure_pay') }}</span>
                                <img src="@/assets/booking_pay.png" alt="" />
                            </div>
                        </div>
                    </div>
                    <div class="booking_btn" @click="payment">
                        <img src="@/assets/credit-card.png" alt="" />
                        <span>{{ $t('checkout') }}</span>
                    </div>
                </div>
            </div>
        </div>
        <!-- 协议 -->
        <el-dialog :before-close="handlerTermsClose" :visible.sync="termsShow" :show-close="true" top="20px"
            ><Terms
        /></el-dialog>
        <el-dialog :before-close="handlerPolicyClose" :visible.sync="policyShow" :show-close="true" top="20px">
            <Policy />
        </el-dialog>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
import Terms from '../Terms/Terms.vue'
import Policy from '../Policy/Policy.vue'
import { check_Mail, checkAllNull } from '@/libs/form'
import { inserSeoElement } from '@/libs/utils'
export default {
    name: 'Fun',
    components: {
        Terms,
        Policy,
    },
    data() {
        return {
            weekCh: ['星期天', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'],
            userInfo: {},
            menus_book: false,
            // 时间和小时
            selectTime: '',
            selectHours: '',
            timeOptions: [
                {
                    value: '8:00',
                    label: '上午 8 点',
                },
                {
                    value: '9:00',
                    label: '上午 9 点',
                },
                {
                    value: '10:00',
                    label: '上午 10 点',
                },
                {
                    value: '11:00',
                    label: '上午 11 点',
                },
                {
                    value: '12:00',
                    label: '上午 12 点',
                },
                {
                    value: '13:00',
                    label: '下午 1 点',
                },
                {
                    value: '14:00',
                    label: '下午 2 点',
                },
                {
                    value: '15:00',
                    label: '下午 3 点',
                },
                {
                    value: '16:00',
                    label: '下午 4 点',
                },
                {
                    value: '17:00',
                    label: '下午 5 点',
                },
                {
                    value: '18:00',
                    label: '下午 6 点',
                },
                {
                    value: '19:00',
                    label: '下午 7 点',
                },
                {
                    value: '20:00',
                    label: '下午 8 点',
                },
                {
                    value: '21:00',
                    label: '下午 9 点',
                },
                {
                    value: '22:00',
                    label: '下午 10 点',
                },
                {
                    value: '23:00',
                    label: '下午 11 点',
                },
            ],
            // hoursOptions: [
            //     {
            //         value: '1',
            //         label: '1 个小时',
            //     },
            //     {
            //         value: '2',
            //         label: '2 个小时',
            //     },
            //     {
            //         value: '3',
            //         label: '3 个小时',
            //     },
            //     {
            //         value: '4',
            //         label: '4 个小时',
            //     },
            //     {
            //         value: '5',
            //         label: '5 个小时',
            //     },
            //     {
            //         value: '6',
            //         label: '6 个小时',
            //     },
            //     {
            //         value: '7',
            //         label: '7 个小时',
            //     },
            //     {
            //         value: '8',
            //         label: '8 个小时',
            //     },
            //     {
            //         value: '9',
            //         label: '9 个小时',
            //     },
            //     {
            //         value: '10',
            //         label: '10 个小时',
            //     },
            //     {
            //         value: '11',
            //         label: '11 个小时',
            //     },
            //     {
            //         value: '12',
            //         label: '12 个小时',
            //     },
            // ],
            //特殊套餐
            cateringComboPackage: [],
            specialServicePackage: [],
            payTotal: {},
            params: {},
            // 同意条款
            serviceChecked: false,
            cancellationChecked: false,
            // 支付节流
            state: true,
            // 协议弹窗
            termsShow: false,
            policyShow: false,
        }
    },
    computed: {
        ...mapGetters(['book']),
        hoursOptions() {
            const length = 27 - this.dayjs(this.userInfo.date + ' ' + this.selectTime).hour()
            const arr = []
            for (let i = 1; i <= length; i++) {
                arr.push({
                    value: i,
                    label: i + '个小时',
                })
            }
            return arr
        },
    },
    created() {
        // 跳转到这个页面时去拿到用户信息进行渲染
        this.userInfo = { ...this.$store.state.home.userOrderInfo }
        this.selectTime = this.userInfo.time
        this.selectHours = this.userInfo.hour ? this.userInfo.hour + '个小时' : ''
        this.calcYachtOrderTotal()
        // 获取当前游艇详情
        this.$store.dispatch('order/getYachtsDetail', {
            productId: this.userInfo.productId,
            passengerNum: +this.userInfo.adult + +this.userInfo.child,
            takeOrderType: this.userInfo.takeOrderType,
            rentDate: this.userInfo.rentDate,
        })
    },
    methods: {
        // 点击预览套餐图片
        previewPic() {
            document.querySelector('body').style.overflow = 'auto'
        },
        // 协议弹窗
        toService() {
            this.termsShow = true
        },
        handlerTermsClose() {
            this.termsShow = false
        },
        toPolicy() {
            this.policyShow = true
        },
        handlerPolicyClose() {
            this.policyShow = false
        },
        // 选择持续时间
        changeSelectHours() {
            this.userInfo.hour = this.selectHours
            this.setLocValue({ hour: this.selectHours })
            this.calcYachtOrderTotal()
        },
        // 选择时间
        orderSelectTime() {
            this.userInfo.time = this.selectTime
            this.setLocValue({ time: this.selectTime })
            this.selectHours = 1
            this.changeSelectHours()
        },
        // 发送计算金额请求
        async calcYachtOrderTotal() {
            this.params = {
                productId: this.userInfo.productId,
                adultNum: +this.userInfo.adult,
                childNum: +this.userInfo.child,
                takeOrderType: this.userInfo.takeOrderType,
                rentType: this.userInfo.rentType,
                rentDate: this.dayjs(this.userInfo.date).format('YYYY-MM-DD'),
                addRentHours: '', // 追加租赁时长
            }
            // 如果选择了时间
            if (this.selectTime) {
                this.params['beginTime'] = this.selectTime
                this.params['endTime'] = `${
                    +this.selectTime.split(':')[0] + +this.userInfo.hour > 9
                        ? +this.selectTime.split(':')[0] + +this.userInfo.hour
                        : '0' + (+this.selectTime.split(':')[0] + +this.userInfo.hour)
                }:00`
                // if (+this.selectTime.split(':')[0] + +this.userInfo.hour >= 24) {
                //     this.$message.warning(this.$t('bookOrder.error'))
                //     return
                // }
            }
            if (!this.selectTime || !this.selectHours) {
                this.$message.warning(this.$t('bookOrder.enterToast'))
                return
            }
            // if (
            //     +this.selectTime.split('P')[0] + 12 + +this.userInfo.hour >= 24 ||
            //     +this.selectTime.split('A')[0] + +this.userInfo.hour >= 24
            // ) {
            //     this.$message.warning(this.$t('bookOrder.error'))
            //     return
            // }
            if (this.cateringComboPackage.length > 0) {
                this.params['cateringComboPackage'] = JSON.stringify(this.cateringComboPackage)
            }
            if (this.specialServicePackage.length > 0) {
                this.params['specialServicePackage'] = JSON.stringify(this.specialServicePackage)
            }

            if (this.dayjs(this.params.rentDate + ' ' + this.params.beginTime).hour() + +this.userInfo.hour >= 24) {
                this.params.endTime = '23:59'
                this.params.addRentHours =
                    this.dayjs(this.params.rentDate + ' ' + this.params.beginTime).hour() + this.userInfo.hour - 24
            }

            try {
                await this.$store.dispatch('order/calcYachtOrderTotal', this.params)
            } catch (error) {}
            // 每次请求后拿到最新的价钱
            this.payTotal = this.$store.state.order.calcYachtOrderTotal
        },
        // 餐饮套餐
        menus(number, id) {
            if (this.cateringComboPackage.length > 0) {
                // 判断数量变化
                let temp = this.cateringComboPackage.find(item => item.id == id)
                temp ? (temp.number = number) : this.cateringComboPackage.push({ id, number })
            } else {
                this.cateringComboPackage.push({ id, number })
            }
            // console.log(this.cateringComboPackage);
            // 调用金额请求函数
            this.calcYachtOrderTotal()
        },
        // 水上运动套餐
        sportsCheckedChange(checked, number, id) {
            if (checked) {
                this.specialServicePackage.push({ id, number: number ? number : 0 })
            } else {
                this.specialServicePackage = this.specialServicePackage.filter(item => item.id !== id)
            }
            this.calcYachtOrderTotal()
        },
        // 选择水上运动套餐发请求
        sportsNumChange(checked, number, id) {
            if (checked) {
                this.specialServicePackage.forEach(item => {
                    if (item.id == id) {
                        item.number = number
                    }
                })
                this.calcYachtOrderTotal()
            }
        },
        // 选择玩具套餐发请求
        toysNumChange(checked, number, id) {
            if (checked) {
                this.specialServicePackage.forEach(item => {
                    if (item.id == id) {
                        item.number = number
                    }
                })
                this.calcYachtOrderTotal()
            }
        },
        toysCheckedChange(checked, number, id) {
            if (checked) {
                this.specialServicePackage.push({ id, number })
            } else {
                this.specialServicePackage = this.specialServicePackage.filter(item => item.id !== id)
            }
            this.calcYachtOrderTotal()
        },
        // 点击支付时调用
        async payment() {
            // 判断是否勾选了协议
            if (this.serviceChecked == false || this.cancellationChecked == false) {
                this.$message.warning(this.$t('bookOrder.agree'))
                return
            }
            if (this.selectTime == '' || this.selectHours == '') {
                this.$message.warning(this.$t('bookOrder.enterToast'))
                return
            }

            if (!check_Mail(this.userInfo.email) || !checkAllNull(this.userInfo.email)) {
                return this.$message({
                    type: 'warning',
                    message: this.$t('form.emailCheck'),
                })
            }

            let data = this.params
            data.realName = this.userInfo.name
            data.mobileNum = data.mobileNum = this.userInfo.code + '-' + this.userInfo.phone
            data.email = this.userInfo.email
            this.setLocValue({ email: this.userInfo.email })
            let orderMemberInfoCmds = []
            for (let i = 1; i <= +this.userInfo.adult; i++) {
                orderMemberInfoCmds.push({
                    memberName: 'Unknown Name',
                    memberType: 1,
                    memberState: 0,
                })
            }
            for (let i = 1; i <= +this.userInfo.child; i++) {
                orderMemberInfoCmds.push({
                    memberName: 'Unknown Name',
                    memberType: 2,
                    memberState: 0,
                })
            }
            data.orderMemberInfoCmds = JSON.stringify(orderMemberInfoCmds)
            if (this.state) {
                this.state = false
                try {
                    await this.$store.dispatch('order/addYachtsOrder', data)
                    this.state = true
                } catch (error) {
                    this.state = true
                }
            }
        },
        // 本地存储筛选信息
        setLocValue(params) {
            // 本地存储用户信息
            this.$store.commit('home/getUserOrderInfo', {
                ...this.$store.state.home.userOrderInfo,
                ...params,
            })
        },
        close_submit() {
            this.menus_book = false
        },
        tour_submit() {
            // this.menus_book = false
        },
    },
    mounted() {
        inserSeoElement(
            'SKY WALKER YACHTS-Yacht Rental Dubai',
            'Yacht Rental Dubai,Charter Yacht Dubai,Luxury Yacht Charter,Yacht Booking Dubai,Rent Yacht Dubai',
            'Experience our luxurious yachts in Dubai. Click here to book now your private yacht rental in Dubai with a professional cabin crew.rent a yacht for cruises, fishing and watersports for best prices.Skywalker yachts offers a luxurious experience on board from our well maintained luxurious fleet. Schedule Your Trip. Book Now. Book Your Yacht Today. Call Us.',
        )
    },
}
</script>
<style scoped src="@/styles/super.css"></style>
<style scoped src="@/styles/Fun.scss" lang="scss"></style>
<style lang="less" scoped>
// .overFlow {
//   margin-right: calc(100% - 100vw);
// }
.boards_menus {
    .el-image {
        top: 7px;
        left: 2px;
    }
}
/deep/.el-dialog__headerbtn {
    font-size: 30px;
}
/deep/.el-dialog__header {
    padding: 0;
}
.booking_form {
    /deep/.el-input__prefix,
    .el-input__suffix {
        top: -6px;
        left: 15px;
    }
}
/deep/.el-form-item__content {
    display: flex;
}

.OrderPhone {
    .Order_booking_code {
        /deep/ input {
            width: 99px;
        }
    }
    .booking_mobile {
        /deep/input {
            margin-left: 6px;
        }
    }
}

.selectHours {
    /deep/.el-select-dropdown__list {
        width: 218px;
    }
}
.boards_main .boards_details {
    padding-right: 40px;
}
.boards_main .boards_menus {
    padding-right: 40px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.textHidden {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

/deep/.el-dialog__body {
    padding: 0;
}
.guestsForm {
    .guestsAdult {
        width: 184px;
        margin-right: 6px;
    }
    .guestsChild {
        width: 184px;
    }
    /deep/.el-input__inner {
        width: 184px;
    }
}
.Yacht_Toys {
    .toys_price {
        width: 200px;
    }
    .toys_detail {
        width: 220px;
        text-align: end;
    }
    .toys_lock {
        padding-right: 10px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
}
</style>
